import type { EmployeeInput } from '@vivaldis/graphql'
import { format } from 'date-fns'
import type { EditEmployeeProfileFormValues } from '../provider/FormProvider'

export const employeeFormValuesToEmployeeInput = (
  values: EditEmployeeProfileFormValues
): EmployeeInput => {
  return {
    email: values.email,
    mobile: values.mobile,
    profile: {
      placeOfBirth: values.placeOfBirth,
      street: values.street,
      streetNumber: values.streetNumber,
      buildingNumber: values.buildingNumber,
      zip: values.zip,
      city: values.city,
      countryId: values.countryId,
      countryOfBirthId: values.countryOfBirthId
    },
    workProfile: {
      bankAccount: values.bankAccount,
      bic: values.bic || null,
      isRetired: values.isRetired,
      retiredOn: values.retiredOn
        ? format(values.retiredOn, 'yyyy-MM-dd')
        : null
    }
  }
}
